var map = {
	"./arganil-1.jpg": 222,
	"./blue-arrow.svg": 223,
	"./cantanhede-1.jpg": 224,
	"./cantanhede-2.jpg": 225,
	"./cantanhede-3.jpg": 226,
	"./coimbra-1.jpg": 227,
	"./coimbra-2.jpg": 228,
	"./coimbra-3.jpg": 229,
	"./coimbra-4.jpg": 230,
	"./coimbra-5.jpg": 231,
	"./condeixa-1.jpg": 232,
	"./condeixa-2.jpg": 233,
	"./condeixa-3.jpg": 234,
	"./condeixa-4.jpg": 235,
	"./contacts-hero.png": 57,
	"./events-hero.png": 24,
	"./figueira-1.jpg": 236,
	"./figueira-2.jpg": 237,
	"./figueira-3.jpg": 238,
	"./figueira-4.jpg": 239,
	"./frame.jpg": 43,
	"./gastronomy-makers.png": 32,
	"./gastronomy-products.jpg": 22,
	"./gastronomy-recipes.jpg": 30,
	"./gastronomy-restaurants.jpg": 18,
	"./gastronomy-tours.png": 31,
	"./gois-1.jpg": 240,
	"./gois-2.jpg": 241,
	"./gois-3.jpg": 242,
	"./gois-4.jpg": 243,
	"./home-display-1.jpg": 58,
	"./home-display-2.jpg": 59,
	"./home-display-3.jpg": 60,
	"./home-gastronomy.jpg": 61,
	"./home-happening.jpg": 62,
	"./lousa-1.jpg": 244,
	"./lousa-2.jpg": 245,
	"./lousa-3.jpg": 246,
	"./lousa-4.jpg": 247,
	"./lousa-5.jpg": 248,
	"./mealhada-1.jpg": 249,
	"./mealhada-2.jpg": 250,
	"./mealhada-3.jpg": 251,
	"./mealhada-4.jpg": 252,
	"./mealhada-pampilhosa-1.jpg": 253,
	"./mealhada-pampilhosa-2.jpg": 254,
	"./mealhada-pampilhosa-3.jpg": 255,
	"./mercados/logo_CIM_rc.svg": 55,
	"./mercados/logo_regiao_coimbra.svg": 54,
	"./mercados/logo_valorizar.png": 56,
	"./mira-1.jpg": 256,
	"./mira-2.jpg": 257,
	"./mira-3.jpg": 258,
	"./mira-4.jpg": 259,
	"./miranda-1.jpg": 260,
	"./miranda-2.jpg": 261,
	"./miranda-3.jpg": 262,
	"./miranda-4.jpg": 263,
	"./montemor-1.jpg": 264,
	"./montemor-2.jpg": 265,
	"./montemor-3.jpg": 266,
	"./montemor-4.jpg": 267,
	"./montemor-5.jpg": 268,
	"./mortagua-1.jpg": 269,
	"./mortagua-2.jpg": 270,
	"./mortagua-3.jpg": 271,
	"./mortagua-4.jpg": 272,
	"./news-hero.png": 23,
	"./oliveira-hospital-1.jpg": 273,
	"./oliveira-hospital-2.jpg": 274,
	"./oliveira-hospital-3.jpg": 275,
	"./pampilhosa-1.jpg": 276,
	"./pampilhosa-2.jpg": 277,
	"./pampilhosa-3.jpg": 278,
	"./pampilhosa-4.jpg": 279,
	"./penacova-1.jpg": 280,
	"./penela-1.jpg": 281,
	"./penela-2.jpg": 282,
	"./penela-3.jpg": 283,
	"./poiares-1.jpg": 284,
	"./poiares-2.jpg": 285,
	"./poiares-3.jpg": 286,
	"./poiares-4.jpg": 287,
	"./producers-hero.png": 52,
	"./project-about.png": 44,
	"./project-goals.jpg": 63,
	"./project-hero.jpg": 33,
	"./project-region-left.jpg": 64,
	"./project-region-right.jpg": 34,
	"./project-regions.png": 65,
	"./recipe-hero.png": 50,
	"./regions/Aarhus.jpg": 66,
	"./regions/Catalonia.jpg": 67,
	"./regions/Coimbra.png": 68,
	"./regions/East_Lombardy.jpg": 69,
	"./regions/Galway.jpg": 70,
	"./regions/Kuopio.jpg": 71,
	"./regions/Minho.jpg": 72,
	"./regions/North_Brabant.jpg": 73,
	"./regions/Riga.jpg": 74,
	"./regions/Sibiu.jpg": 75,
	"./regions/Slovenia.jpg": 76,
	"./regions/South_Aegean.jpg": 77,
	"./rota-mercados.jpg": 49,
	"./rota_mercados_logo.svg": 53,
	"./soure-1.jpg": 288,
	"./soure-2.jpg": 289,
	"./soure-3.jpg": 290,
	"./soure-4.jpg": 291,
	"./soure-5.jpg": 292,
	"./tabua-1.jpg": 293,
	"./tabua-2.jpg": 294,
	"./tabua-3.jpg": 295,
	"./tabua-4.jpg": 296,
	"./thumbnail-mercado.jpg": 297,
	"./tours-hero.png": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;